import typography from '../typography';

export default {
  '@global': {
    body: typography.body1,
  },
};
